import {useEffect,useState} from 'react';
import {FiMoon,FiSun} from 'react-icons/fi';

export default function ThemeToggle(){
  const [theme,setTheme]=useState(()=>localStorage.getItem('codex-theme')||'dark');
  useEffect(()=>{
    document.documentElement.dataset.theme=theme;
    localStorage.setItem('codex-theme',theme);
  },[theme]);
  const next=theme==='dark'?'light':'dark';
  return <button className="theme-toggle" type="button" onClick={()=>setTheme(next)} aria-label={`Switch to ${next} mode`} title={`Switch to ${next} mode`}><span>{theme==='dark'?<FiSun/>:<FiMoon/>}</span></button>;
}
